module.exports = __webpack_public_path__ + "static/media/videoadmobile.65508524.mp4";